import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function CompassIcon(_ref) {
  var rotate = _ref.rotate;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/forbid-elements
    _jsxs("svg", {
      viewBox: "0 0 12 32",
      width: "32px",
      height: "32px",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsx("path", {
        transform: rotate ? "rotate(".concat(rotate, " 6 16)") : '',
        d: "M5.051.846c.304-.912 1.594-.912 1.898 0l4.946 14.838a1 1 0 010 .632L6.949 31.154c-.304.912-1.594.912-1.898 0L.105 16.316a1 1 0 010-.632L5.051.846z",
        fill: "url(#paint0_Compass_linear)"
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsxs("linearGradient", {
          id: "paint0_Compass_linear",
          x1: "6",
          y1: "-2",
          x2: "6",
          y2: "34",
          gradientUnits: "userSpaceOnUse",
          children: [/*#__PURE__*/_jsx("stop", {
            offset: ".499",
            stopColor: "red"
          }), /*#__PURE__*/_jsx("stop", {
            offset: ".501",
            stopColor: "#fff"
          })]
        })
      })]
    })
  );
}